var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41908 3.41908C2.9912 3.84696 2.75 4.66007 2.75 6.44V12.78C2.75 14.5603 2.99134 15.3727 3.41858 15.7992C3.8456 16.2254 4.65785 16.465 6.43789 16.46L6.44 16.46L17.56 16.46C19.3414 16.46 20.1539 16.2209 20.5814 15.7942C21.0085 15.3678 21.25 14.5556 21.25 12.77V6.44C21.25 4.66 21.0088 3.84736 20.5802 3.41958C20.1511 2.99129 19.3353 2.75 17.55 2.75H6.44C4.66007 2.75 3.84696 2.9912 3.41908 3.41908ZM2.35842 2.35842C3.26304 1.4538 4.66993 1.25 6.44 1.25H17.55C19.3247 1.25 20.7339 1.45371 21.6398 2.35792C22.5462 3.26264 22.75 4.67 22.75 6.44V12.77C22.75 14.5444 22.5465 15.9522 21.6411 16.8558C20.7361 17.7591 19.3286 17.96 17.56 17.96H6.44109C4.67161 17.9649 3.26422 17.7644 2.35892 16.8608C1.45366 15.9573 1.25 14.5497 1.25 12.78V6.44C1.25 4.66993 1.4538 3.26304 2.35842 2.35842Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.4697C12.4142 16.4697 12.75 16.8055 12.75 17.2197V21.9997C12.75 22.4139 12.4142 22.7497 12 22.7497C11.5858 22.7497 11.25 22.4139 11.25 21.9997V17.2197C11.25 16.8055 11.5858 16.4697 12 16.4697Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 13C1.25 12.5858 1.58579 12.25 2 12.25H22C22.4142 12.25 22.75 12.5858 22.75 13C22.75 13.4142 22.4142 13.75 22 13.75H2C1.58579 13.75 1.25 13.4142 1.25 13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 22C6.75 21.5858 7.08579 21.25 7.5 21.25H16.5C16.9142 21.25 17.25 21.5858 17.25 22C17.25 22.4142 16.9142 22.75 16.5 22.75H7.5C7.08579 22.75 6.75 22.4142 6.75 22Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.247785de.svg";
export { ForwardRef as ReactComponent };